module.exports = __webpack_public_path__ + "static/media/livros-thumbnail.28092022.webp";